import axios from 'axios'

export const internalClient = axios.create({
  baseURL: '/local/custom-shop-api/',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
})
